import { render, staticRenderFns } from "./TermsScreen.vue?vue&type=template&id=02d79e1b&scoped=true"
import script from "./TermsScreen.vue?vue&type=script&lang=js"
export * from "./TermsScreen.vue?vue&type=script&lang=js"
import style0 from "./TermsScreen.vue?vue&type=style&index=0&id=02d79e1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d79e1b",
  null
  
)

export default component.exports